<template>
  <a-row class="content-fix main-tabs" type="flex">
    <spinner v-if="loading" />
    <a-col v-show="!loading" class="height100 flex-1 d-flex flex-column">
      <!-- tabs -->
      <a-tabs
        :key="$route.fullPath"
        class="flex-1"
        type="card"
        @change="$emit('tabPaneChange', arguments[1])"
      >
        <a-tab-pane key="content">
          <span slot="tab"> <a-icon type="project" />Содержимое </span>
          <a-row
            align="middle"
            class="flex-baseline"
            style="margin-bottom: 15px"
          >
            <a-col :span="6" style="text-align: right; padding-right: 8px">
              Язык:
            </a-col>
            <a-col :span="18">
              <!-- lang translit tabs -->
              <a-row align="middle" class="flex-baseline flex-wrap">
                <lang-tabs v-model="tabs.lang_prefix" class="mb-1x" />
              </a-row>
            </a-col>
          </a-row>
          <!-- tabs -->
          <a-row style="margin-bottom: 15px">
            <a-col
              :span="6"
              style="text-align: right; padding-top: 5px; padding-right: 8px"
            >
              Ссылка:
            </a-col>

            <a-col :span="18">
              <a-textarea
                v-model="form.link[tabs.lang_prefix]"
                :auto-size="{ minRows: 3 }"
              />
            </a-col>
          </a-row>
        </a-tab-pane>

        <!-- photo tab -->
        <a-tab-pane key="photo">
          <span slot="tab"> <a-icon type="picture" />Фото </span>

          <a-row align="middle" style="margin-bottom: 10px">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Язык:
            </a-col>

            <a-col :span="12">
              <!-- Lang tabs -->
              <lang-tabs v-model="tabs.lang_prefix" class="mb-1x" />
            </a-col>
          </a-row>

          <!-- upload photo -->
          <a-row align="middle">
            <a-col
              :span="6"
              style="padding-top: 4px; text-align: right; padding-right: 8px"
            >
              Изображения:
            </a-col>
            <a-col :span="12">
              <image-upload
                v-for="(item, index) in imagePathProps"
                v-show="item.indexOf(tabs.lang_prefix) != -1"
                :key="index + 1 + '_' + Math.random().toString().slice(2)"
                :with-cropper="false"
                :list="
                  (item &&
                    form[item] && [
                      {
                        [typeof form[item] === 'object'
                          ? 'fileTarget'
                          : 'file']: form[item]
                      }
                    ]) ||
                  []
                "
                accept="image/jpeg, image/png"
                :multiple="false"
                :some-arg="typeof form[item] === 'File' ? 'string' : 'File'"
                @change="$emit('change', arguments[0])"
              />
            </a-col>
          </a-row>
        </a-tab-pane>

        <span v-if="form.id" slot="tabBarExtraContent">
          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="$emit('submit')"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
          <a-popconfirm
            placement="bottomRight"
            title="Вы действительно хотите удалить данный новость?"
            @confirm="$emit('delete')"
          >
            <a-button :disabled="pending" style="margin-right: 10px">
              <a-icon type="delete" />Удалить
            </a-button>
          </a-popconfirm>
        </span>
      </a-tabs>

      <!-- actions -->
      <a-row class="form-buttons__action" type="flex">
        <a-col :span="6" style="text-align: right; padding-right: 8px" />
        <a-col>
          <a-button :disabled="pending" @click="$router.go(-1)">
            <a-icon type="close" />Отмена
          </a-button>

          <a-button
            :loading="pending"
            style="margin-left: 10px"
            type="primary"
            @click="$emit('submit')"
          >
            <a-icon type="check" />
            {{ form.id ? "Сохранить" : "Добавить" }}
          </a-button>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
// import { required } from "vuelidate/lib/validators";

export default {
  components: {
    "image-upload": () => import("@/components/utils/image-upload")
  },
  props: {
    form: {
      type: Object,
      default: () => ({})
    },

    pending: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    },

    tabs: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    imagePathProps() {
      return Object.keys(this.form).filter(
        (item) => item.indexOf("image_file") !== -1
      )
    }
  }
}
</script>
